import { BASE_DOMAIN } from "env";

export const SOCKET_URL = process.env.NODE_ENV === 'test' ? '' : `https://soc.${BASE_DOMAIN}/`;
export const MOBILE_UPLOAD_BASE_URL = `https://web.${BASE_DOMAIN}/ui/mobile-upload`;
export const TWILIO_SUCCESS_ISH_STATUS_CODES = ["accepted", "queued", "sending", "sent", "delivered"];